export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  articleCount: number;
}

export const categories: Category[] = [
  {
    slug: "keji-qianyan",
    name: "科技前沿",
    description: "探索人工智能、区块链、量子计算等前沿科技的最新突破与应用，把握数字化时代的脉搏，洞见技术革新如何重塑我们的未来生活方式。",
    icon: "ri-cpu-line",
    articleCount: 28,
  },
  {
    slug: "shenghuo-meixue",
    name: "生活美学",
    description: "发现日常生活中的艺术与美好，从家居设计到美食烹饪，从旅行探索到个人成长，用心感受每一个值得被珍视的精致瞬间。",
    icon: "ri-leaf-line",
    articleCount: 35,
  },
  {
    slug: "renwen-sheke",
    name: "人文社科",
    description: "深入人文思想与社会科学的广阔领域，解读历史脉络、哲学思辨、社会变迁与文化传承，拓展认知边界，启迪独立思考。",
    icon: "ri-book-open-line",
    articleCount: 22,
  },
  {
    slug: "shangye-caijing",
    name: "商业财经",
    description: "紧跟全球经济动态与商业创新趋势，深度解析企业战略、投资理念、市场洞察与创业故事，为决策者提供有价值的智慧参考。",
    icon: "ri-line-chart-line",
    articleCount: 31,
  },
  {
    slug: "jiankang-yangsheng",
    name: "健康养生",
    description: "传播科学健康理念与传统养生智慧，涵盖营养膳食、运动健身、心理健康与中医调理，助您构建身心平衡的优质生活。",
    icon: "ri-heart-pulse-line",
    articleCount: 19,
  },
  {
    slug: "wenhua-yishu",
    name: "文化艺术",
    description: "品味东西方文化精髓与艺术魅力，从古典传承到当代创新，从文学创作到视觉艺术，感受人类创造力的无限可能。",
    icon: "ri-palette-line",
    articleCount: 26,
  },
];